var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppCard',{staticClass:"cancellation-card",attrs:{"design":"new","padding":"none"}},[_c('header',{staticClass:"cancellation-card__header"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_vm._t("actions")],2),_c('div',{staticClass:"cancellation-card__body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }